import { Button } from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
import AddEntityModal from "features/entities/AddEntityModal";
import { getFundEntityTableDataRetrieveQueryKey } from "gen/endpoints/fund-entities-table-data/fund-entities-table-data";
import { getGlobalEntityTableDataRetrieveQueryKey } from "gen/endpoints/global-entity-table-data/global-entity-table-data";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import { useTranslation } from "react-i18next";
import { Restricted } from "shared/components/access/Restricted";
import { useConfirmationDialog } from "shared/components/modal/confirm/ConfirmationDialog";
import { useToast } from "shared/components/toast/useToast";

export interface AddEntityButtonProps {
  fundFamilyId?: string;
  size?: "xs" | "sm" | "md";
}

export const AddEntityButton: React.FC<AddEntityButtonProps> = ({
  fundFamilyId,
  size,
}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(["entity"]);
  const { showToast } = useToast();

  const confirmAddEntity = useConfirmationDialog(AddEntityModal, {
    fundFamilyId,
    onSuccess: () => {
      showToast({ message: t("entity:add.success"), variant: "success" });
      void queryClient.invalidateQueries({
        queryKey: getGlobalEntityTableDataRetrieveQueryKey(),
      });
      if (fundFamilyId) {
        void queryClient.invalidateQueries({
          queryKey: getFundEntityTableDataRetrieveQueryKey(fundFamilyId),
        });
      }
    },
  });

  return (
    <Restricted permission={PermissionTypeEnum.config}>
      <Button onClick={async () => await confirmAddEntity()} size={size}>
        {t("entity:createEntity")}
      </Button>
    </Restricted>
  );
};
